import React from 'react';
import { isValidUrl } from '@common/utils/isValidUrl';

import styles from './AuthorInfo.module.scss';
import { ImageInfoIcon } from "@kursk/components/ui/icons";

export const AuthorInfo = ({ image }) => {
  if (image){
    return (
      <>
        <div className={styles.imageSource}>
          <ImageInfoIcon/>
        </div>
        <div className={styles.imagePopup}>
          {isValidUrl(image.url) ? (
            <a href={image.url} target="_blank" rel="noreferrer" className={styles.ellipsis}>
              {image.sourceTitle}
            </a>
          ) : (
            <div className={styles.ellipsis}>
              {`${image.url} / ${image.sourceTitle}`}
            </div>
          )}
        </div>
      </>
    );
  }
};
